import Text from './Text/Text';
import Percent from './Percent/Percent';
import Currency from './Currency/Currency';
import Select from './Select/Select';
import DateSelector from './DatePicker/DatePicker';
import Search from './Search/Search';
import Switcher from './Switcher/Switcher';
import Checkbox from './Checkbox/Checkbox';
import Radio from './Radio/Radio';
import FileUpload from './FileUpload/FileUpload';
import WYSIWYGEditor from './WYSIWYGEditor/WYSIWYGEditor';

export const v2 = {
  Text,
  Percent,
  Currency,
  Select,
  DateSelector,
  Search,
  Switcher,
  Checkbox,
  Radio,
  FileUpload,
  WYSIWYGEditor
};
